import dynamic from 'next/dynamic';
import React, { useRef } from 'react';

import { WishlistModalWrapper } from '@/components/wishlists/WishlistModal';
import { IWishlistingEventData } from '@/services/analytics/listings/types';
import { TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { ISearchResultTile } from '@/utility/mapSearchResultToTile';

import { FavoriteToggleButton } from './FavoriteToggleButton';

const FavoriteToggleAnimation = dynamic(
  () => import('./FavoriteToggleAnimation').then(m => m.FavoriteToggleAnimation),
  { ssr: false },
);

type TListingTileFavoriteToggleProps = {
  listingTile: ISearchResultTile | TAutoRentalTile;
  wishlistingEventData?: IWishlistingEventData;
  showFavoriteToggleAnimation?: boolean;
};

export const ListingTileFavoriteToggle = ({
  listingTile,
  wishlistingEventData,
  showFavoriteToggleAnimation,
}: TListingTileFavoriteToggleProps) => {
  const heartIconContainerRef = useRef<HTMLDivElement>(null);

  if (listingTile.loading) return null;

  const { isFavorite, favoriteCount } = listingTile;

  return (
    <>
      <WishlistModalWrapper
        item={listingTile}
        itemType="rental"
        isFavorite={isFavorite}
        wishlistingEventData={wishlistingEventData}
        TriggerComponent={({ toggleFavorite }) => (
          <FavoriteToggleButton
            iconRef={heartIconContainerRef}
            isFavorite={isFavorite}
            favoriteCount={favoriteCount}
            onClick={toggleFavorite}
          />
        )}
      />

      {showFavoriteToggleAnimation && (
        <FavoriteToggleAnimation containerRef={heartIconContainerRef} isFavorite={isFavorite} />
      )}
    </>
  );
};
